import Nullstack from 'nullstack';
export default function IconGenderTransgender({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gender-transgender",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "12",
    r: "4"
  }), "   ", Nullstack.element("path", {
    d: "M15 9l6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M21 7v-4h-4"
  }), "   ", Nullstack.element("path", {
    d: "M9 9l-6 -6"
  }), "   ", Nullstack.element("path", {
    d: "M3 7v-4h4"
  }), "   ", Nullstack.element("path", {
    d: "M5.5 8.5l3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M12 16v5"
  }), "   ", Nullstack.element("path", {
    d: "M9.5 19h5"
  }), " ");
}